<template lang="html">
  <div class="play" @click="yo">
    <svg id="play" xmlns="http://www.w3.org/2000/svg" width="1000" height="1000" viewBox="0 0 1000 1000">
  	  <title>play</title>
  	  <g id="Layer_2" data-name="Layer 2">
  	    <rect width="1000" height="1000" style="fill: none"/>
  	  </g>
  	  <g id="Layer_1" data-name="Layer 1">
  	    <path id="Y" d="M835.10411,570.82564,709.06139,771.27937,569.351,570.82564M709.06092,926.55522V771.27949" style="fill: none"/>
  	    <path id="A" d="M143.40182,924.2773,292.22357,573.10356h14.04694L456.61083,924.2773m-237.27955-175.397H380.6814" style="fill: none"/>
  	    <path id="L" d="M821.06073,436.12287H583.16792V84.94912" style="fill: none"/>
  	    <path id="P" d="M177.41085,439.072V86H327.5732a94.53216,94.53216,0,1,1,0,189.06431H181.20732" style="fill: none"/>
  	  </g>
  	</svg>
  </div>
</template>

<script>
import {TweenMax, Power0, Elastic} from 'gsap/TweenMax'

export default {
  beforeDestroy () {
    // let self = this
    // window.removeEventListener('resize', self.animate)
  },
  mounted () {
    // let self = this
    // window.addEventListener('resize', self.animate)
    this.animate()
  },
  data () {
    return {
      currentStyle: 1
    }
  },
  methods: {
    animate () {
      console.log('animate')
      TweenMax.fromTo('path', 2, {
        'stroke-dashoffset': 0
      }, {
        'stroke-dashoffset': 90,
        repeat: -1,
        ease: Power0.easeNone
      })

      this.yo()
    },
    yo () {
      this.shuffle_style()
      this.path_bounce()
    },
    path_bounce () {
      TweenMax.fromTo('#play path', 2, {
        'stroke-width': 10
      }, {
        'stroke-width': 50 + Math.random() * 50,
        ease: Elastic.easeOut.config(1.5, 0.2)
      })
    },
    shuffle_style () {
      let stroke = Math.random() * 70 + 10
      let gap = 90 - stroke
      let style0 = {
        'stroke-width': 20,
        // 'stroke-dasharray': '10 80',
        'stroke-dasharray': `${gap} ${stroke}`,
        'stroke-linecap': 'square',
        'stroke-linejoin': 'square'
      }
      let style1 = {
        'stroke-width': 20,
        // 'stroke-dasharray': '40 50',
        'stroke-dasharray': `${stroke} ${gap}`,
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round'
      }
      let style2 = {
        'stroke-width': 20,
        // 'stroke-dasharray': '10 20 10 20 10 20',
        'stroke-dasharray': `${stroke / 3} ${gap / 3} ${stroke / 3} ${gap / 3} ${stroke / 3} ${gap / 3}`,
        'stroke-linecap': 'butt',
        'stroke-linejoin': 'miter'
      }
      switch (this.currentStyle) {
        case 0:
          TweenMax.set('#play path', style0)
          this.currentStyle = 1
          break
        case 1:
          TweenMax.set('#play path', style1)
          this.currentStyle = 2
          break
        case 2:
          TweenMax.set('#play path', style2)
          this.currentStyle = 0
          break
      }
    }
  }
}
</script>

<style scoped>
.play {
  background: yellow;
  width: 100%;
  height: 37.5vw;
  cursor: pointer;
}
svg {
  width: 100%;
  height: 100%;
}
path {
  stroke: black;
}

#Y {
  /* transform: translate(20px, 0px); */
  transform: translate(420px, -250px)
}
#A {
  /* transform: translate(-30px, 0px); */
  transform: translate(420px, -250px)
}
#L {
  /* transform: translate(30px, -10px); */
  transform: translate(-400px, 240px)
}
#P {
  /* transform: translate(-10px, 0px); */
  transform: translate(-410px, 250px)
}
#Layer_1 {
  transform-origin: center;
  transform: scale(1.25)
}
@media screen and (max-width: 1024px) {
  .play {
    height: 100vw;
  }
  #Layer_1 {
    transform-origin: center;
    transform: scale(1)
  }
  #Y {
    transform: translate(20px, 0px);
    /* transform: translate(420px, -250px) */
  }
  #A {
    transform: translate(-30px, 0px);
    /* transform: translate(420px, -250px) */
  }
  #L {
    transform: translate(30px, -10px);
    /* transform: translate(-430px, 240px) */
  }
  #P {
    transform: translate(-10px, 0px);
    /* transform: translate(-410px, 250px) */
  }
}
</style>



// WEBPACK FOOTER //
// Play.vue?524ff63e